// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5d7236cfdc2485522dc9","135":"2f2127714da5bad58ac2","136":"e49f4653867979ae9b2f","174":"292abc733a198c541f23"}[chunkId] + ".chunk.js";
};